/**
 * @file 读取语言
 * @author zhujialu
 * @author dujianhao
 */
define(function (require, exports, module) {
    'use strict'

    var urlUtil = require('cc/util/url')
    var inClient = require('./inClient')
    var storage = require('../feature/storage')

    // 从 storage 中读取用户偏好
    storage.init()
    var userPreferredLanguage = storage.get(storage.SYSTEM_LANGUAGE)

    var map = {
        chinese: 1,
        english: 1
    }

    function getSystemLanguage() {
        // 老的 IE 中 userLanguage 和 language 一直是 en，只有 systemLanguage 会随系统变化
        return navigator.systemLanguage || navigator.browserLanguage || navigator.userLanguage || navigator.language
    }

    function isChinese(language) {
        return language.indexOf('zh-cn') === 0 || language === 'zh'
    }

    return function () {
        if (window.BJYLang === 'chinese') {
            return 'chinese'
        }

        // url 中 query 的语言优先级最高
        var language = urlUtil.parseQuery(location.search).language
        if (!map[language]) {
            // 其次读取用户偏好
            if (userPreferredLanguage) {
                return userPreferredLanguage
            }

            // 最后读取系统语言
            language = getSystemLanguage()
            language = language.toLowerCase()
            if (
                inClient()
                && (!window.bjyAppVersion || (BJY.store.get('cefApiVersion') && !BJY.checkVersion('6.8.5')))
            ) {
                // 早期的客户端全是英文
                if (isChinese(language) || language.indexOf('en') === 0) {
                    language = 'chinese'
                }
                else {
                    language = 'english'
                }
            }
            else {
                if (isChinese(language)) {
                    language = 'chinese'
                }
                else {
                    language = 'english'
                }
            }
        }

        return language
    }
})
